import { errorTracker, SentryErrorTracker } from '@/shared/lib/error-tracking';
import { apiConfigAccessor } from '@stores/webStorages/storages/ApiConfig.accessor';

export const initializeErrorTracking = () => {
  const config = apiConfigAccessor.getConfig();
  const dsn = config?.REACT_APP_SENTRY_DSN;
  const environment = config?.REACT_APP_SENTRY_ENV;

  if (!dsn || !environment) {
    return;
  }

  errorTracker.configure(new SentryErrorTracker(), {
    environment,
    dsn,
  });
};
